// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.complete-btn[data-v-2abf6a09] {\n  z-index: 2;\n}\nbutton.complete-btn[disabled][data-v-2abf6a09] {\n    background-color: var(--v-ecdgray-lighten5) !important;\n}\n", ""]);
// Exports
module.exports = exports;
